<template>
  <div class="pcSetting">
    <el-button
      type="primary"
      size="small"
      style="position: absolute; right: 30px; top: 0"
      @click="saveSchoolPage"
      >保存</el-button
    >
    <el-select
      @change="templateChange"
      placeholder="请选择"
      v-model="choosedTemplate"
      size="mini"
      style="position: absolute; right: 96px; top: 3px; height: 30px"
    >
      <el-option
        v-for="item in tempOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <div class="pcSettingMain">
      <div class="pcLeft">
        <div class="pcLeftItem" @click="addModule(1, '轮播图')">
          <div style="font-size: 30px" class="iconfont icon-lunbotu"></div>
          <div style="font-size: 13px">轮播图</div>
        </div>
        <div class="pcLeftItem" @click="addModule(2, '商品课程')">
          <div
            style="font-size: 30px"
            class="iconfont icon-shangpinkecheng"
          ></div>
          <div style="font-size: 13px">商品课程</div>
        </div>
        <div class="pcLeftItem" @click="addModule(3, '新闻资讯')">
          <div style="font-size: 30px" class="iconfont icon-xinwen"></div>
          <div style="font-size: 13px">新闻资讯</div>
        </div>
        <div class="pcLeftItem" @click="addModule(4, '课程分类')">
          <div
            style="font-size: 30px"
            class="iconfont icon-kechengfenlei"
          ></div>
          <div style="font-size: 13px">课程分类</div>
        </div>
        <div class="pcLeftItem" @click="addModule(5, '友情链接')">
          <div style="font-size: 30px" class="iconfont icon-lianjie"></div>
          <div style="font-size: 13px">友情链接</div>
        </div>
      </div>
      <div class="pcCenter">
        <div class="pageContainer" id="pcCenterMain">
          <draggable
            v-model="homePageList"
            @update="datadragEndContent"
            :options="{ animation: 500 }"
          >
            <div
              v-for="(pageItem, pageIndex) in homePageList"
              :key="pageItem.id"
            >
              <div
                :class="
                  pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                "
                @mouseenter="hoverModule(pageIndex)"
                @mouseleave="leaveModule(pageIndex)"
                @click="activeModule(pageIndex)"
                v-if="pageItem.type == 1"
                :key="pageItem.id"
              >
                <div
                  class="iconfont icon-shanchu"
                  v-if="pageItem.moduleHover"
                  @click="deleteModule(pageIndex)"
                ></div>
                <template
                  v-if="
                    pageItem.schoolPageItemList &&
                    pageItem.schoolPageItemList.length > 0
                  "
                >
                  <el-carousel trigger="click" height="400px">
                    <el-carousel-item
                      v-for="item in pageItem.schoolPageItemList"
                      :key="item.id"
                    >
                      <img
                        :src="item.picture"
                        style="height: 100%; width: 100%"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </template>
                <template v-else>
                  <div class="emptyDiv">轮播图</div>
                </template>
              </div>
              <div
                class="mainContent"
                v-if="pageItem.type == 2"
                :key="pageItem.id"
              >
                <div
                  :class="
                    pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                  "
                  @mouseenter="hoverModule(pageIndex)"
                  @mouseleave="leaveModule(pageIndex)"
                  @click="activeModule(pageIndex)"
                >
                  <div
                    class="iconfont icon-shanchu"
                    v-if="pageItem.moduleHover"
                    @click="deleteModule(pageIndex)"
                  ></div>
                  <template
                    v-if="
                      pageItem.schoolPageItemList &&
                      pageItem.schoolPageItemList.length > 0
                    "
                  >
                    <div class="moudleTitle">{{ pageItem.title }}</div>
                    <div class="moudleGoodsMain flex">
                      <div
                        class="moudleGoodsItem"
                        v-for="item in pageItem.schoolPageItemList"
                        :key="item.id"
                      >
                        <img :src="item.goodsInfo.logo" />
                        <div class="moudleGoodsName font2Line">
                          {{ item.goodsInfo.name }}
                        </div>
                        <div class="flex moudleGoodsEnd">
                          <div class="moudleGoodsSell">
                            {{ item.goodsInfo.sellCount }}人报名
                          </div>
                          <div class="moudleGoodsPrice">
                            ￥<span>{{ item.goodsInfo.price }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="emptyDiv">商品课程</div>
                  </template>
                </div>
              </div>
              <div
                class="mainContent"
                v-if="pageItem.type == 3"
                :key="pageItem.id"
              >
                <div
                  :class="
                    pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                  "
                  @mouseenter="hoverModule(pageIndex)"
                  @mouseleave="leaveModule(pageIndex)"
                  @click="activeModule(pageIndex)"
                >
                  <div
                    class="iconfont icon-shanchu"
                    v-if="pageItem.moduleHover"
                    @click="deleteModule(pageIndex)"
                  ></div>
                  <template
                    v-if="
                      pageItem.schoolPageItemList &&
                      pageItem.schoolPageItemList.length > 0
                    "
                  >
                    <div class="moudleTitle">{{ pageItem.title }}</div>
                    <div class="moudleNewsMain flex">
                      <img :src="pageItem.picture" />
                      <div class="newsTitleMain">
                        <div
                          class="font1Line"
                          v-for="item in pageItem.schoolPageItemList"
                          :key="item.id"
                        >
                          {{ item.information.title }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="emptyDiv">新闻资讯</div>
                  </template>
                </div>
              </div>
              <div
                class="mainContent"
                v-if="pageItem.type == 4"
                :key="pageItem.id"
              >
                <div
                  :class="
                    pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                  "
                  @mouseenter="hoverModule(pageIndex)"
                  @mouseleave="leaveModule(pageIndex)"
                  @click="activeModule(pageIndex)"
                >
                  <div
                    class="iconfont icon-shanchu"
                    v-if="pageItem.moduleHover"
                    @click="deleteModule(pageIndex)"
                  ></div>
                  <template
                    v-if="
                      pageItem.schoolPageItemList &&
                      pageItem.schoolPageItemList.length > 0
                    "
                  >
                    <div class="moudleTitle">{{ pageItem.title }}</div>
                    <div class="moudleGoodsMain flex">
                      <div
                        class="moudleGoodsItem"
                        v-for="item in pageItem.schoolPageItemList"
                        :key="item.id"
                      >
                        <img :src="item.goodsInfo.logo" />
                        <div class="moudleGoodsName font2Line">
                          {{ item.goodsInfo.name }}
                        </div>
                        <div class="flex moudleGoodsEnd">
                          <div class="moudleGoodsSell">
                            {{ item.goodsInfo.sellCount }}人报名
                          </div>
                          <div class="moudleGoodsPrice">
                            ￥<span>{{ item.goodsInfo.price }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="emptyDiv">课程分类</div>
                  </template>
                </div>
              </div>
              <div
                class="mainContent"
                v-if="pageItem.type == 5"
                :key="pageItem.id"
              >
                <div
                  :class="
                    pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                  "
                  @mouseenter="hoverModule(pageIndex)"
                  @mouseleave="leaveModule(pageIndex)"
                  @click="activeModule(pageIndex)"
                >
                  <div
                    class="iconfont icon-shanchu"
                    v-if="pageItem.moduleHover"
                    @click="deleteModule(pageIndex)"
                  ></div>
                  <div class="parentLinkMain">
                    <div style="font-size: 16px">{{ pageItem.title }}</div>
                    <div class="flex parentLinkItem">
                      <div
                        v-for="item in pageItem.schoolPageItemList"
                        :key="item.id"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>

          <!-- <div class="mainContent">
          <div class="moduleMain" @mouseenter="hoverModule" @mouseleave="leaveModule">
            <div class="iconfont icon-shanchu" v-if="moduleHover" @click="deleteModule"></div>
            <div class="moudleTitle">热门课程</div>
            <div class="moudleGoodsMain flex">
              <div class="moudleGoodsItem"  v-for="item in 8" :key="item" @click="toCourseInfo()">
                <img src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/15936691447872720147462.jpg"/>
                <div class="moudleGoodsName font2Line">2020年中级会计职称-零基础私教班</div>
                <div class="flex moudleGoodsEnd">
                  <div class="moudleGoodsSell">2220人报名</div>
                  <div class="moudleGoodsPrice">￥<span>2000</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="moduleMain">
            <div class="moudleTitle">最新上线</div>
            <div class="moudleGoodsMain flex">
              <div class="moudleGoodsItem"  v-for="item in 4" :key="item" @click="toCourseInfo()">
                <img src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/15936691447872720147462.jpg"/>
                <div class="moudleGoodsName font2Line">2020年中级会计职称-零基础私教班2020年中级会计职称-零基础私教班</div>
                <div class="flex moudleGoodsEnd">
                  <div class="moudleGoodsSell">2220人报名</div>
                  <div class="moudleGoodsPrice">￥<span>2000</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="moduleMain">
            <div class="moudleTitle">新闻资讯</div>
            <div class="moudleNewsMain flex">
              <img src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/15936691447872720147462.jpg"/>
              <div class="newsTitleMain">
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">2020初级会计考前冲刺打卡第一期，快来呀！</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">2020初级会计考前冲刺打卡第一期，快来呀！</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
                <div class="font1Line">初级会计备考经验：0基础职场小白转战初级 高分也不难</div>
              </div>
            </div>
          </div>
          <div class="moduleMain">
            <div class="moudleTitle">会计类</div>
            <div class="moudleGoodsMain flex">
              <div class="moudleGoodsItem"  v-for="item in 4" :key="item" @click="toCourseInfo()">
                <img src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/15936691447872720147462.jpg"/>
                <div class="moudleGoodsName font2Line">2020年中级会计职称-零基础私教班2020年中级会计职称-零基础私教班</div>
                <div class="flex moudleGoodsEnd">
                  <div class="moudleGoodsSell">2220人报名</div>
                  <div class="moudleGoodsPrice">￥<span>2000</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="moduleMain">
            <div class="moudleTitle">自考类</div>
            <div class="moudleGoodsMain flex">
              <div class="moudleGoodsItem"  v-for="item in 4" :key="item" @click="toCourseInfo()">
                <img src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/15936691447872720147462.jpg"/>
                <div class="moudleGoodsName font2Line">2020年中级会计职称-零基础私教班2020年中级会计职称-零基础私教班</div>
                <div class="flex moudleGoodsEnd">
                  <div class="moudleGoodsSell">2220人报名</div>
                  <div class="moudleGoodsPrice">￥<span>2000</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="moduleMain">
            <div class="parentLinkMain">
              <div style="font-size:16px">友情链接</div>
              <div class="flex parentLinkItem">
                <div>考试吧</div><div>考试吧</div><div>考试吧</div><div>考试吧</div><div>考试吧</div><div>考试吧</div>
              </div>
            </div>
          </div>
        </div> -->
        </div>
      </div>
      <div class="pcRight">
        <!--        
       <div class="pcRight-title">
         <div>轮播图</div>
         <el-switch
          v-model="state"
          active-color="#266ef6">
        </el-switch>
       </div>
       <div>
         <div>添加内容</div>
         <div class="pcRightTips">最多添加5个轮播图，拖动选中的轮播图可对其排序，建议尺寸1920*500像素</div>
         <div class="lunboItem flex">
           <div>

           </div>
           <div>

           </div>
         </div>
       </div> -->
        <div class="operation">
          <div v-if="!activeType" class="operation-1">
            <div class="operation-1-text">请点击选中左侧模块区域进行编辑</div>
          </div>

          <div v-if="homePageList.length > 0">
            <div v-if="activeType == 1">
              <div class="operation-name">轮播图</div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="operation-1-text1">
                  最多添加12个轮播图，拖动选中的轮播图可对其排序，建议尺寸750*260像素
                </div>
              </div>
              <div
                class="operation-2"
                v-if="
                  homePageList[activeIndex] &&
                  homePageList[activeIndex].schoolPageItemList
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <!-- <transition-group> -->
                  <div
                    class="operation-2-list"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="item.id"
                  >
                    <div class="list-img">
                      <el-upload
                        class="crm-upload"
                        :action="fileObj.url"
                        :before-upload="lbtbeforeUpload"
                        :on-success="lbtSuccessUpdate"
                        :headers="reqData"
                        :show-file-list="false"
                      >
                        <img
                          class="list-img"
                          :src="item.picture"
                          @click="updateImg(index)"
                          alt
                        />
                        <div class="list-img-uptext" @click="updateImg(index)">
                          修改
                        </div>
                      </el-upload>
                    </div>
                    <div class="list-msg">
                      <div class="list-msg-item">
                        <span style="width: 50px">标题</span>
                        <el-input
                          size="mini"
                          style="width: 200px"
                          placeholder="选填"
                          v-model="item.title"
                          clearable
                        ></el-input>
                      </div>

                      <div class="list-msg-item">
                        <span style="width: 50px">链接</span>
                        <el-input
                          style="width: 140px"
                          @input="changeInput(index)"
                          size="mini"
                          v-if="item.type == 2"
                          v-model="item.title"
                          clearable
                        ></el-input>
                        <el-input
                          style="width: 140px"
                          size="mini"
                          @input="changeInput(index)"
                          v-else-if="item.linkUrl"
                          v-model="item.linkUrl"
                          clearable
                        ></el-input>
                        <el-dropdown trigger="click" @command="handleCommand">
                          <span
                            class="el-dropdown-link"
                            style="
                              color: rgb(77, 148, 255);
                              cursor: pointer;
                              margin-left: 10px;
                            "
                          >
                            {{
                              item.linkUrl || item.type == 2
                                ? "修改"
                                : "选择跳转到的页面"
                            }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item :command="1+'-'+index">页面路径</el-dropdown-item> -->
                            <el-dropdown-item :command="2 + '-' + index"
                              >商品课程</el-dropdown-item
                            >
                            <el-dropdown-item :command="4 + '-' + index"
                              >外部链接</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <i
                      class="el-icon-delete operation-delete"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                  <!-- </transition-group> -->
                </draggable>
              </div>
              <div class="operation-2-button">
                <el-upload
                  style="width: 100%"
                  class="crm-upload"
                  :action="fileObj.url"
                  :before-upload="lbtbeforeUpload"
                  :on-success="lbtSuccess"
                  :headers="reqData"
                  multiple
                  :show-file-list="false"
                >
                  <el-button icon="el-icon-plus" style="width: 380px"
                    >添加轮播图</el-button
                  >
                </el-upload>
              </div>
            </div>

            <div v-if="activeType == 2">
              <div class="operation-name">商品课程</div>
              <div class="line"></div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="label-show" style="margin-top: 20px">
                  <span style="width: 50px">标题:</span>
                  <el-input
                    size="mini"
                    style="width: 200px"
                    placeholder="选填"
                    v-if="homePageList[activeIndex]"
                    v-model="homePageList[activeIndex].title"
                    clearable
                  ></el-input>
                </div>
                <el-radio-group
                  v-model="homePageList[activeIndex].sortType"
                  @change="changeSortType()"
                >
                  <el-radio :label="1">热门</el-radio>
                  <el-radio :label="2">最新</el-radio>
                  <el-radio :label="3">自定义</el-radio>
                </el-radio-group>
                <div
                  class="operation-1-text1"
                  v-if="homePageList[activeIndex].sortType != 3"
                >
                  实时显示
                  <el-dropdown trigger="click" @command="handleCommandCapacity">
                    <span
                      class="el-dropdown-link"
                      style="color: rgb(77, 148, 255); cursor: pointer"
                    >
                      {{ homePageList[activeIndex].capacity }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <!-- <el-dropdown-item :command="1+'-'+index">页面路径</el-dropdown-item> -->
                      <el-dropdown-item :command="4">4</el-dropdown-item>
                      <el-dropdown-item :command="8">8</el-dropdown-item>
                    </el-dropdown-menu> </el-dropdown
                  >个
                  <template v-if="homePageList[activeIndex].sortType == 1"
                    >热门</template
                  >
                  <template v-if="homePageList[activeIndex].sortType == 2"
                    >最新</template
                  >
                  课程
                </div>
              </div>
              <div class="operation-2">
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="label-show chunk"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="index"
                  >
                    <span style="width: 50px">课程:</span>
                    <span style="color: #4d94ff; width: 260px">{{
                      item.title
                    }}</span>
                    <i
                      class="el-icon-delete chunk-delete"
                      v-if="homePageList[activeIndex].sortType == 3"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>

                <div
                  class="operation-2-button"
                  v-if="homePageList[activeIndex].sortType == 3"
                >
                  <el-button
                    icon="el-icon-plus"
                    style="width: 100%"
                    @click="openaddFormVisible(2)"
                    >添加课程</el-button
                  >
                </div>
              </div>
            </div>

            <div v-if="activeType == 3">
              <div class="operation-name">新闻资讯</div>
              <div class="line"></div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="label-show" style="margin-top: 20px">
                  <span style="width: 50px">标题:</span>
                  <el-input
                    size="mini"
                    style="width: 200px"
                    placeholder="选填"
                    v-if="homePageList[activeIndex]"
                    v-model="homePageList[activeIndex].title"
                    clearable
                  ></el-input>
                </div>
                <div class="label-show" style="margin-top: 20px">
                  <span style="width: 50px">封面:</span>
                  <el-upload
                    style="margin-left: 10px"
                    :action="fileObj.url"
                    :before-upload="lbtbeforeUpload"
                    :on-success="infomationSuccessUpdate"
                    :headers="reqData"
                    :show-file-list="false"
                  >
                    <img
                      style="width: 60px; height: 60px; border: 1px solid #eee"
                      :src="homePageList[activeIndex].picture"
                      alt
                    />
                  </el-upload>
                </div>
              </div>

              <div class="operation-2">
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="label-show chunk"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="index"
                  >
                    <span style="width: 50px">资讯:</span>
                    <span style="color: #4d94ff; width: 260px">{{
                      item.title
                    }}</span>
                    <i
                      class="el-icon-delete chunk-delete"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>

                <div class="operation-2-button">
                  <el-button
                    icon="el-icon-plus"
                    style="width: 100%"
                    @click="openaddInformationForm()"
                    >添加资讯</el-button
                  >
                </div>
              </div>
            </div>

            <div v-if="activeType == 4">
              <div class="operation-name">课程分类</div>
              <div class="line"></div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="label-show" style="margin-top: 20px">
                  <span style="width: 50px">标题:</span>
                  <el-input
                    size="mini"
                    style="width: 200px"
                    placeholder="选填"
                    v-if="homePageList[activeIndex]"
                    v-model="homePageList[activeIndex].title"
                    clearable
                  ></el-input>
                </div>
                <div class="label-show" style="margin-top: 20px">
                  <span style="width: 50px">分类:</span>
                  <el-select
                    v-model="homePageList[activeIndex].typeId"
                    placeholder="请选择类目"
                    clearable
                    @change="changeSortType()"
                    size="mini"
                  >
                    <el-option
                      v-for="item in subjectPList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-radio-group
                  v-model="homePageList[activeIndex].sortType"
                  @change="changeSortType()"
                >
                  <el-radio :label="1">热门</el-radio>
                  <el-radio :label="2">最新</el-radio>
                  <el-radio :label="3">自定义</el-radio>
                </el-radio-group>
                <div
                  class="operation-1-text1"
                  v-if="homePageList[activeIndex].sortType != 3"
                >
                  实时显示
                  <el-dropdown trigger="click" @command="handleCommandCapacity">
                    <span
                      class="el-dropdown-link"
                      style="color: rgb(77, 148, 255); cursor: pointer"
                    >
                      {{ homePageList[activeIndex].capacity }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <!-- <el-dropdown-item :command="1+'-'+index">页面路径</el-dropdown-item> -->
                      <el-dropdown-item :command="4">4</el-dropdown-item>
                      <el-dropdown-item :command="8">8</el-dropdown-item>
                    </el-dropdown-menu> </el-dropdown
                  >个
                  <template v-if="homePageList[activeIndex].sortType == 1"
                    >热门</template
                  >
                  <template v-if="homePageList[activeIndex].sortType == 2"
                    >最新</template
                  >
                  课程
                </div>
              </div>
              <div class="operation-2">
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="label-show chunk"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="index"
                  >
                    <span style="width: 50px">课程:</span>
                    <span style="color: #4d94ff; width: 260px">{{
                      item.title
                    }}</span>
                    <i
                      class="el-icon-delete chunk-delete"
                      v-if="homePageList[activeIndex].sortType == 3"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>

                <div
                  class="operation-2-button"
                  v-if="homePageList[activeIndex].sortType == 3"
                >
                  <el-button
                    icon="el-icon-plus"
                    style="width: 100%"
                    @click="openaddFormVisible(2)"
                    >添加课程</el-button
                  >
                </div>
              </div>
            </div>

            <div v-if="activeType == 5">
              <div class="operation-name">友情链接</div>
              <div class="line"></div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
              </div>
              <div
                class="operation-2"
                v-if="
                  homePageList[activeIndex] &&
                  homePageList[activeIndex].schoolPageItemList
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <!-- <transition-group> -->
                  <div
                    class="operation-2-list"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="item.id"
                  >
                    <div class="list-msg">
                      <div class="list-msg-item">
                        <span style="width: 50px">标题</span>
                        <el-input
                          size="mini"
                          style="width: 200px"
                          placeholder="选填"
                          v-model="item.title"
                          clearable
                        ></el-input>
                      </div>

                      <div class="list-msg-item">
                        <span style="width: 50px">链接</span>
                        <el-input
                          style="width: 200px"
                          size="mini"
                          v-model="item.linkUrl"
                          clearable
                        ></el-input>
                      </div>
                    </div>
                    <i
                      class="el-icon-delete operation-delete"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                  <!-- </transition-group> -->
                </draggable>
              </div>
              <div class="operation-2-button">
                <el-button
                  icon="el-icon-plus"
                  style="width: 100%"
                  @click="addUrlLink()"
                  >添加链接</el-button
                >
              </div>
            </div>
          </div>
        </div>

        <el-dialog
          :title="'添加商品'"
          :visible.sync="addFormVisible"
          width="60%"
          left
          :close-on-click-modal="false"
        >
          <el-form :label-width="formLabelWidth">
            <el-row :span="24">
              <el-col :sm="9" :md="9" :lg="9">
                <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
                  <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                    <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>-->
                <el-form-item label="所属科目" label-width="80px" prop="pid">
                  <el-cascader
                    :show-all-levels="false"
                    ref="tree"
                    collapse-tags
                    @change="subjectChange"
                    :options="subjectTreeList"
                    :props="subjectTreeProps"
                    clearable
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :sm="9" :md="9" :lg="9">
                <el-form-item label="商品名称">
                  <el-input v-model="searchForm.name"></el-input>
                </el-form-item>
              </el-col>

              <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
                <el-button type="primary" @click="getList()">查询</el-button>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :sm="24" :md="24" :lg="24">
                <el-table
                  :data="tableList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  highlight-current-row
                  @current-change="selectionChange"
                  border
                  v-loading="loading1"
                  element-loading-text="拼命加载中"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                >
                  <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    label="商品"
                  >
                    <template slot-scope="row">
                      <el-row>
                        <el-col :span="8">
                          <span>
                            <img
                              style="margin-right: 10px"
                              width="100%"
                              height="44px"
                              :src="
                                row.row.logo
                                  ? row.row.logo
                                  : '../../../static/image/noImg.png'
                              "
                            />
                          </span>
                        </el-col>
                        <el-col :span="16">
                          <span
                            style="color: rgb(77, 148, 255); margin-left: 10px"
                            >{{ row.row.name }}</span
                          >
                          <span style="display: block; margin-left: 10px">
                            <span style="color: red"
                              >￥{{ row.row.price }}</span
                            >
                            <span
                              style="
                                text-decoration: line-through;
                                color: rgb(162, 170, 188);
                              "
                              >￥{{ row.row.originalPrice }}</span
                            >
                          </span>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    width="200"
                    prop="agentPrice"
                    label="售价"
                  >
                    <template slot-scope="row">
                      <span style="display: block">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span
                          style="
                            text-decoration: line-through;
                            color: rgb(162, 170, 188);
                          "
                          >￥{{ row.row.originalPrice }}</span
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="validDay"
                    width="100"
                    label="有效期"
                  >
                    <template slot-scope="row">{{
                      row.row.validDay ? row.row.validDay + "天" : "不限"
                    }}</template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    width="200"
                    prop="subjectCourseName"
                    label="所属科目"
                  ></el-table-column>
                </el-table>
                <el-pagination
                  background
                  layout="total, prev, pager, next"
                  style="margin-top: 20px; text-align: right"
                  :total="page.total"
                  :page-size="page.pageSize"
                  :current-page="page.pageNumber"
                  @size-change="sizeChange"
                  @current-change="currentChange"
                ></el-pagination>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button @click="addFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="closeDialog">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          :title="'添加商品'"
          :visible.sync="addFormVisibleSpkc"
          width="60%"
          left
          :close-on-click-modal="false"
        >
          <el-form :label-width="formLabelWidth">
            <el-row :span="24">
              <el-col :sm="9" :md="9" :lg="9">
                <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
                  <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                    <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>-->
                <el-form-item label="所属科目" label-width="80px" prop="pid">
                  <el-cascader
                    :show-all-levels="false"
                    ref="tree"
                    collapse-tags
                    @change="subjectChange"
                    :options="subjectTreeList"
                    :props="subjectTreeProps"
                    clearable
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :sm="9" :md="9" :lg="9">
                <el-form-item label="商品名称">
                  <el-input v-model="searchForm.name"></el-input>
                </el-form-item>
              </el-col>

              <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
                <el-button type="primary" @click="getList()">查询</el-button>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :sm="24" :md="24" :lg="24">
                <el-table
                  :data="tableList"
                  style="width: 100%"
                  @selection-change="selectionChangeCpkc"
                  border
                  v-loading="loading1"
                  element-loading-text="拼命加载中"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                >
                  <el-table-column
                    show-overflow-tooltip
                    type="selection"
                    width="55"
                  ></el-table-column>
                  <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    label="商品"
                  >
                    <template slot-scope="row">
                      <el-row>
                        <el-col :span="8">
                          <span>
                            <img
                              style="margin-right: 10px"
                              width="100%"
                              height="44px"
                              :src="
                                row.row.logo
                                  ? row.row.logo
                                  : '../../../static/image/noImg.png'
                              "
                            />
                          </span>
                        </el-col>
                        <el-col :span="16">
                          <span
                            style="color: rgb(77, 148, 255); margin-left: 10px"
                            >{{ row.row.name }}</span
                          >
                          <span style="display: block; margin-left: 10px">
                            <span style="color: red"
                              >￥{{ row.row.price }}</span
                            >
                            <span
                              style="
                                text-decoration: line-through;
                                color: rgb(162, 170, 188);
                              "
                              >￥{{ row.row.originalPrice }}</span
                            >
                          </span>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    width="200"
                    prop="agentPrice"
                    label="售价"
                  >
                    <template slot-scope="row">
                      <span style="display: block">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span
                          style="
                            text-decoration: line-through;
                            color: rgb(162, 170, 188);
                          "
                          >￥{{ row.row.originalPrice }}</span
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="validDay"
                    width="100"
                    label="有效期"
                  >
                    <template slot-scope="row">{{
                      row.row.validDay ? row.row.validDay + "天" : "不限"
                    }}</template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    width="200"
                    prop="subjectCourseName"
                    label="所属科目"
                  ></el-table-column>
                </el-table>

                <el-pagination
                  background
                  layout="total, prev, pager, next"
                  style="margin-top: 20px; text-align: right"
                  :total="page.total"
                  :page-size="page.pageSize"
                  :current-page="page.pageNumber"
                  @size-change="sizeChange"
                  @current-change="currentChange"
                ></el-pagination>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button @click="addFormVisibleSpkc = false">取 消</el-button>
            <el-button type="primary" @click="closeDialog">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="自定义链接"
          :visible.sync="addFormVisible3"
          width="40%"
          left
        >
          <el-form label-width="80px">
            <el-row :span="24">
              <el-col :sm="24" :md="24" :lg="24">
                <el-form-item label="链接地址">
                  <el-input style="width: 100%" v-model="linkUrl"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button @click="addFormVisible3 = false">取 消</el-button>
            <el-button type="primary" @click="closeDialog3">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          :title="'添加资讯'"
          :visible.sync="addopenaddInformationFormVisible"
          width="60%"
          left
          :close-on-click-modal="false"
        >
          <el-form :label-width="formLabelWidth">
            <el-row :span="24">
              <el-col :sm="9" :md="9" :lg="9">
                <el-form-item label="资讯名称">
                  <el-input v-model="informationSearchForm.title"></el-input>
                </el-form-item>
              </el-col>

              <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
                <el-button type="primary" @click="getInformationList()"
                  >查询</el-button
                >
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :sm="24" :md="24" :lg="24">
                <el-table
                  :data="informationList"
                  style="width: 100%"
                  @selection-change="selectionChangeInformation"
                  border
                  v-loading="loading1"
                  element-loading-text="拼命加载中"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                >
                  <el-table-column
                    show-overflow-tooltip
                    type="selection"
                    width="55"
                  ></el-table-column>
                  <el-table-column
                    prop="title"
                    show-overflow-tooltip
                    label="新闻资讯"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.title }}
                    </template>
                  </el-table-column>
                </el-table>

                <el-pagination
                  background
                  layout="total, prev, pager, next"
                  style="margin-top: 20px; text-align: right"
                  :total="informationPage.total"
                  :page-size="informationPage.pageSize"
                  :current-page="informationPage.pageNumber"
                  @size-change="informationSizeChange"
                  @current-change="informationCurrentChange"
                ></el-pagination>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button @click="addopenaddInformationFormVisible = false"
              >取 消</el-button
            >
            <el-button type="primary" @click="addInformation">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      tempOptions: [],
      choosedTemplate: "",
      state: 1,
      homePageList: [],
      // activeModuleId:'',
      activeIndex: "",
      activeType: "",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      itemIndex: "",
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: [],
      },
      tableList: [],
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      arrsSelect: [],
      loading1: false,
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children",
      },
      addFormVisible: false,
      checkList: [],
      addFormVisible3: false,
      linkUrl: "",
      formLabelWidth: "80px",
      addFormVisibleSpkc: false,
      addGoodsFormType: 1,
      addopenaddInformationFormVisible: false,
      informationSearchForm: {
        title: "",
      },
      informationPage: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      informationList: [],
      informationCheckList: [],
      subjectPList: [],
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.getTempDictionary(() => {
      this.getHomePageListSetting();
      this.getSubjectPList();
    });
  },
  methods: {
    getTempDictionary(callback) {
      this.api.dictionary
        .getTempDictionaryData()
        .then((result) => {
          this.tempOptions = result.data;
          result.data.forEach((v, k) => {
            if (v.defaultTheme) this.choosedTemplate = v.id;
          });
          console.log(result, this.choosedTemplate);
          callback && callback();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hoverModule(pageIndex) {
      this.$set(this.homePageList[pageIndex], "moduleHover", true);
    },
    leaveModule(pageIndex) {
      if (pageIndex != this.activeIndex) {
        this.$set(this.homePageList[pageIndex], "moduleHover", false);
      }
    },
    activeModule(pageIndex) {
      for (let item of this.homePageList) {
        this.$set(item, "moduleHover", false);
      }
      let homePageListItem = this.homePageList[pageIndex];
      // this.activeModuleId=homePageListItem.id;
      this.activeIndex = pageIndex;
      this.activeType = homePageListItem.type;
      this.$set(this.homePageList[pageIndex], "moduleHover", true);
      console.log(this.activeIndex);
    },
    deleteModule(pageIndex) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.homePageList.splice(pageIndex, 1);
          // this.activeModuleId='';
          this.activeIndex = "";
          this.activeType = "";
        })
        .catch(() => {});
    },
    getHomePageListSetting() {
      this.api.schoolPage
        .getHomePageListSetting(this.choosedTemplate || this.tempOptions[0].id)
        .then((result) => {
          this.loading = false;
          if (result.success) {
            this.homePageList = result.data;
          } else {
            this.homePageList = [];
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    lbtSuccess(res, file, fileList, val) {
      if (!this.homePageList[this.activeIndex].schoolPageItemList) {
        this.homePageList[this.activeIndex].schoolPageItemList = [];
      }
      this.homePageList[this.activeIndex].schoolPageItemList.push({
        picture: res.data,
        title: "",
        type: "1",
        sort: this.homePageList[this.activeIndex].schoolPageItemList.length,
      });
    },
    lbtSuccessUpdate(res, file, fileList, val) {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].picture = res.data;
      this.itemIndex = "";
    },
    infomationSuccessUpdate(res, file, fileList, val) {
      this.homePageList[this.activeIndex].picture = res.data;
      this.itemIndex = "";
    },
    lbtbeforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    datadragEnd(evt) {
      evt.preventDefault();
    },
    datadragEndContent(evt) {
      this.activeModule(evt.newIndex);
      evt.preventDefault();
    },
    updateImg(index) {
      this.itemIndex = index;
    },
    deleteItem(index) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.homePageList[this.activeIndex].schoolPageItemList.splice(
            index,
            1
          );
        })
        .catch(() => {});
    },
    handleCommand(command) {
      // console.log(command);
      let arr = command.split("-");
      let type = arr[0];
      this.itemIndex = arr[1];
      if (type == 1) {
      } else if (type == 2) {
        this.openaddFormVisible(1);
      } else if (type == 4) {
        this.addFormVisible3 = true;
      }
    },
    handleCommandCapacity(command) {
      this.homePageList[this.activeIndex].capacity = command;
      this.changeSortType();
    },
    changeInput(index) {
      this.homePageList[this.activeIndex].schoolPageItemList[index].linkUrl =
        "";
      this.homePageList[this.activeIndex].schoolPageItemList[index].title = "";
      this.homePageList[this.activeIndex].schoolPageItemList[index].type = "";
      this.$forceUpdate();
      // console.log(this.homePageList[this.activeIndex].schoolPageItemList[index])
    },
    openaddFormVisible(type) {
      // this.searchForm.subjectIds=[];
      if (type == 1) {
        this.addGoodsFormType = 1;
        this.addFormVisible = true;
      } else if (type == 2) {
        this.addGoodsFormType = 2;
        // if(this.homePageList[this.activeIndex].typeId){
        //   this.searchForm.subjectIds.push(this.homePageList[this.activeIndex].typeId);
        // }
        this.addFormVisibleSpkc = true;
      }
      this.getList();
      this.api
        .getSubjectTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getList() {
      this.loading1 = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.loading1 = false;
          this.tableList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
        })

        .catch((error) => {
          console.log(error);
        });
    },
    selectionChange(val) {
      this.checkList = val;
    },
    selectionChangeCpkc(val) {
      this.checkList = val;
    },
    selectionChangeInformation(val) {
      this.informationCheckList = val;
    },
    addInformation() {
      console.log(this.activeIndex);
      console.log(this.homePageList[this.activeIndex]);
      console.log(this.homePageList[this.activeIndex].schoolPageItemList);
      if (this.informationCheckList.length > 0)
        this.informationCheckList.forEach((item) => {
          if (this.homePageList[this.activeIndex].schoolPageItemList == null) {
            this.homePageList[this.activeIndex].schoolPageItemList = [];
          }
          this.homePageList[this.activeIndex].schoolPageItemList.push({
            relationId: item.id,
            title: item.title,
            type: 3,
            sort: this.homePageList[this.activeIndex].schoolPageItemList.length,
            information: {
              title: item.title,
            },
          });
        });
      this.addopenaddInformationFormVisible = false;
    },
    closeDialog() {
      if (this.addGoodsFormType == 1) {
        this.homePageList[this.activeIndex].schoolPageItemList[
          this.itemIndex
        ].relationId = this.checkList.id;
        this.homePageList[this.activeIndex].schoolPageItemList[
          this.itemIndex
        ].title = this.checkList.name;
        this.homePageList[this.activeIndex].schoolPageItemList[
          this.itemIndex
        ].type = 2;
        this.homePageList[this.activeIndex].schoolPageItemList[
          this.itemIndex
        ].goodsInfo = {
          name: this.checkList.name,
          logo: this.checkList.logo,
          sellCount: this.checkList.sellCount,
          price: this.checkList.price,
        };
      } else if (this.addGoodsFormType == 2) {
        if (this.checkList.length > 0)
          if (!this.homePageList[this.activeIndex].schoolPageItemList) {
            this.homePageList[this.activeIndex].schoolPageItemList = [];
          }
        this.checkList.forEach((item) => {
          this.homePageList[this.activeIndex].schoolPageItemList.push({
            relationId: item.id,
            title: item.name,
            type: 2,
            sort: this.homePageList[this.activeIndex].schoolPageItemList.length,
            goodsInfo: {
              name: item.name,
              sellCount: item.sellCount,
              logo: item.logo,
              price: item.price,
            },
          });
        });
      }
      this.itemIndex = "";
      this.addFormVisible = false;
      this.addFormVisibleSpkc = false;
    },
    subjectChange(val) {
      if (val) {
        this.searchForm.subjectIds = [];
        val.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    informationSizeChange(pageSize) {
      this.informationPage.pageSize = pageSize;
      this.getInformationList();
    },
    informationCurrentChange(pageNumber) {
      this.informationPage.pageNumber = pageNumber;
      this.getInformationList();
    },
    closeDialog3() {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].linkUrl = this.linkUrl;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].type = 1;
      this.linkUrl = "";
      this.addFormVisible3 = false;
    },
    openaddInformationForm() {
      this.getInformationList();
      this.addopenaddInformationFormVisible = true;
    },
    getInformationList() {
      this.loading1 = true;
      this.informationSearchForm.pageSize = this.informationPage.pageSize;
      this.informationSearchForm.pageNumber = this.informationPage.pageNumber;
      this.api.schoolPage
        .informationPageList(this.informationSearchForm)
        .then((result) => {
          this.loading1 = false;
          this.informationList = result.data.records;
          this.informationPage.total = result.data.total;
        })

        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectPList() {
      this.api.schoolPage
        .getSubjectPList({})
        .then((result) => {
          this.subjectPList = result.data;
        })

        .catch((error) => {
          console.log(error);
        });
    },
    addUrlLink() {
      if (!this.homePageList[this.activeIndex].schoolPageItemList) {
        this.homePageList[this.activeIndex].schoolPageItemList = [];
      }
      this.homePageList[this.activeIndex].schoolPageItemList.push({
        title: "",
        linkUrl: "http://",
        type: 4,
        sort: this.homePageList[this.activeIndex].schoolPageItemList.length,
      });
    },
    addModule(type, title) {
      if (!this.homePageList) {
        this.homePageList = [];
      }
      let sortType;
      let capacity;
      let schoolPageItemList = [];
      if (type == 2 || type == 4) {
        sortType = 1;
        capacity = 4;
        let params = {
          sortType: sortType,
          capacity: capacity,
        };
        this.api.schoolPage
          .getGoodsListByType(params)
          .then((result) => {
            if (result.success) {
              let data = result.data;
              if (data) {
                data.forEach((item) => {
                  schoolPageItemList.push({
                    relationId: item.id,
                    title: item.name,
                    type: type,
                    sort: 0,
                    goodsInfo: {
                      name: item.name,
                      sellCount: item.sellCount,
                      logo: item.logo,
                      price: item.price,
                    },
                  });
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.homePageList.push({
        moduleHover: false,
        title: title,
        type: type,
        sort: this.homePageList.length,
        schoolPageItemList: schoolPageItemList,
        sortType: sortType,
        templateId: this.choosedTemplate,
        capacity: capacity,
      });
      this.$nextTick(function () {
        var container = this.$el.querySelector("#pcCenterMain");
        container.scrollTop = container.scrollHeight;
      });
    },
    saveSchoolPage() {
      this.api.schoolPage
        .updateHomeSchoolPage(this.choosedTemplate, this.homePageList)
        .then((result) => {
          if (result.success) {
            this.activeIndex = "";
            this.activeType = "";
            this.getHomePageListSetting();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    templateChange() {
      this.getHomePageListSetting();
      console.log(this.choosedTemplate);
    },
    changeSortType() {
      this.homePageList[this.activeIndex].schoolPageItemList = [];
      let params = {
        sortType: this.homePageList[this.activeIndex].sortType,
        capacity: this.homePageList[this.activeIndex].capacity,
        typeId: this.homePageList[this.activeIndex].typeId,
      };
      let type = this.homePageList[this.activeIndex].type;
      this.api.schoolPage
        .getGoodsListByType(params)
        .then((result) => {
          if (result.success) {
            let data = result.data;
            if (data) {
              data.forEach((item) => {
                this.homePageList[this.activeIndex].schoolPageItemList.push({
                  relationId: item.id,
                  title: item.name,
                  type: type,
                  sort: this.homePageList[this.activeIndex].schoolPageItemList
                    .length,
                  goodsInfo: {
                    name: item.name,
                    sellCount: item.sellCount,
                    logo: item.logo,
                    price: item.price,
                  },
                });
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    // activeModuleId(){
    //   console.log(this.activeModuleId)
    // }
  },
};
</script>
<style lang="less" scoped>
.pcSetting {
  .pcSettingMain {
    display: flex;
    min-height: 700px;
    justify-content: space-between;
    overflow-x: scroll;
  }
  .pcLeft {
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #eee;
  }
  .pcLeftItem {
    width: 60px;
    height: 60px;
    margin-top: 15px;
    padding: 2px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .pcLeftItem:hover {
    background: #266ef6;
    color: #fff;
  }
  .pcRight {
    width: 400px;
    border-left: 1px solid #eee;
    padding: 10px;
    margin-top: 30px;
  }
  .pcRight-title {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }
  .pcCenter {
    // width: 910px;
  }

  // 中间区域css
  .pageContainer {
    padding-bottom: 20px;
    color: #455a64;
    background-color: #f6f7f9;
    height: 700px;
    width: 800px;
    overflow-y: scroll;
  }
  .mainContent {
    width: 700px;
    margin: 0 auto;
  }
  .el-menu {
    border-bottom: none !important;
  }
  .el-menu-item {
    padding: 0;
    margin: 0 20px !important;
    font-size: 16px;
  }
  .flex {
    display: -webkit-flex; /* Safari */
    display: flex;
  }
  .font1Line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .font2Line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .font6Line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }
  .moduleMain {
    margin-top: 20px;
    cursor: pointer;
    position: relative;
    border: 2px solid #f6f7f9;
  }
  .moduleMain.active {
    border: 2px solid #266ef6;
  }
  .moduleMain:hover {
    border: 2px dashed #266ef6;
  }
  .moudleTitle {
    font-size: 24px;
    padding: 10px 0;
  }
  .moudleGoodsMain {
    width: 690px;
    // justify-content: space-between;
    flex-wrap: wrap;
  }
  .moudleNewsMain {
    width: 700px;
  }
  .moudleNewsMain img {
    width: 350px;
    height: 200px;
    border-radius: 5px;
  }
  .moudleGoodsItem {
    width: 166px;
    height: 180px;
    margin-top: 10px;
    border-radius: 5px;
    background-color: #fff;
    margin-left: 5px;
    // cursor: pointer;
  }
  .moudleGoodsItem img {
    height: 100px;
    width: 166px;
    border-radius: 5px;
  }
  .moudleGoodsName {
    padding: 5px 10px 0 10px;
    // font-size: 16px;
    height: 35px;
  }
  .moudleGoodsEnd {
    justify-content: space-between;
    padding: 5px 10px 0 10px;
    align-items: center;
  }
  .moudleGoodsSell {
    color: #a2aabc;
    font-size: 12px;
  }
  .moudleGoodsPrice {
    color: #fc5e5e;
  }
  .moudleGoodsPrice span {
    font-size: 24px;
  }
  .newsTitleMain {
    margin-left: 40px;
    font-size: 16px;
    line-height: 20px;
  }
  .parentLinkMain {
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
  }
  .parentLinkItem {
    flex-wrap: wrap;
  }
  .parentLinkItem div {
    margin: 5px 5px 0 0;
    color: #a2aabc;
    font-size: 12px;
  }
  //结束
  .icon-shanchu {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #79797a;
    color: #fff;
    padding: 4px;
    z-index: 999;
  }
  .pcRightTips {
    color: #a2aabc;
    font-size: 13px;
  }
  .lunboItem {
    width: 420px;
    height: 80px;
  }
  .operation {
    // position: fixed;
    // top: 123px;
    // right: 20px;
    width: 380px;
    height: calc(100% - 0px);
    // background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
    background-color: #fafafa;
    .operation-2 {
      padding: 20px;
      .operation-2-button {
      }
      .operation-2-list:hover {
        .operation-delete {
          display: inline-block;
        }
      }
      .operation-2-list {
        position: relative;
        margin-bottom: 10px;
        background-color: rgba(255, 255, 255, 1);
        border-width: 1px;
        border-style: solid;
        padding: 10px;
        border-color: rgba(238, 238, 238, 1);
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .operation-delete {
          position: absolute;
          bottom: 6px;
          right: 10px;
          z-index: 100;
          cursor: pointer;
          font-size: 14px;
          color: rgba(255, 85, 85, 1);
          display: none;
        }
        .list-msg {
          margin-left: 10px;
          .list-msg-item {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
          }
        }
        .list-img {
          width: 60px;
          height: 60px;
          z-index: 2000;
          position: relative;
          .list-img-uptext {
            z-index: 2000;
            width: 60px;
            height: 20px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #333;
            opacity: 0.6;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
    .operation-1 {
      background-color: rgba(255, 255, 255, 1);
      padding: 20px;
      .operation-1-text {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        color: #455a64;
        line-height: 14px;
      }
      .operation-1-text1 {
        padding-top: 10px;
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #a2aabc;
        line-height: 16px;
      }
    }
    .operation-name {
      background-color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      text-align: left;
      line-height: 60px;
      padding: 0 0 0 20px;
    }
  }
  .label-show {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .chunk {
    height: 40px;
    line-height: 40px;
    padding: 0px 0px 0px 10px;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    .chunk-delete {
      font-size: 14px;
      color: rgba(255, 85, 85, 1);
      display: none;
    }
  }
  .chunk:hover {
    .chunk-delete {
      display: inline-block;
    }
  }
  .emptyDiv {
    border: 2px solid #a2aabc;
    color: #a2aabc;
    font-size: 30px;
    text-align: center;
    line-height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schoolPage/pcSetting.vue